const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import * as telegram from './telegram'
import * as utils from './utils'
import { BaseObject, MongoObject } from './_baseClasses'
import { Account, TeamCS, PlayerCS, SetCS } from './Account'
import { AccountExtraSnapshot } from './AccountExtraSnapshot'

export interface AccountForLeaderboard {
  accountExtra: AccountExtra,
  oneWeekAgo?: AccountExtraSnapshot,   // only for team leaderboards
  oneMonthAgo?: AccountExtraSnapshot,  // only for team leaderboards
  account?: Account
}

export class AccountExtra extends MongoObject {
  protected static collectionName: string = 'accountextras'           // IMPORTANT
  private static NODE_CACHE_TTL: number = 300

  public static LEADERBOARD_MINIMUM_CS1_PLAYER = 100
  public static LEADERBOARD_MINIMUM_CS1_SET = 100
  public static LEADERBOARD_MINIMUM_CS1_TEAM = 100
  public static LEADERBOARD_MINIMUM_CS2_PLAYER = 5000
  public static LEADERBOARD_MINIMUM_CS2_SET = 5000
  public static LEADERBOARD_MINIMUM_CS2_TEAM = 5000
  public static LEADERBOARD_MINIMUM_CS2b_PLAYER = 5000
  public static LEADERBOARD_MINIMUM_CS2b_SET = 5000
  public static LEADERBOARD_MINIMUM_CS2b_TEAM = 5000

  public accountId: string = null
  public dapperID: string = null
  public favoriteTeamID: string = null
  public favoriteTeamMoments: number = null

  // CS 1.0
  public favoriteTeamCS: number = null
  public favoriteTeamCompletions: number[] = null
  public lastKnownTeamRank: number = null             // stopped updating this on May 18th
  public playerCSs: PlayerCS[] = null
  public setCSs: SetCS[] = null

  // CS 2.0
  public favoriteTeamCS2: number = null
  public favoriteTeamCompletions2: number[] = null
  public lastKnownTeamRank2: number = null            //  never used
  public playerCS2s: PlayerCS[] = null
  public setCS2s: SetCS[] = null

  // CS 2b (TSS)
  public favoriteTeamCS2b: number = null
  public favoriteTeamCompletions2b: number[] = null
  public lastKnownTeamRank2b: number = null            // switched to this on May 18th
  public playerCS2bs: PlayerCS[] = null
  public setCS2bs: SetCS[] = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, accountId?: string, dapperID?: string) {
    super()
    if (po) this.injectPlainObject(po)
    if (accountId) this.accountId = accountId
    if (dapperID) this.dapperID = dapperID
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  // when sending to client
  public makeSafeForClient(): AccountExtra {
    return this
  }

  public isSafe(): boolean {
    return true
  }

  public static getClassNameBasedOnSeries(series: number): string {
    switch (series) {
      case -1: return 'ultimate';
      case 0: return 'legendary';
      case 1: return 'rare';
      case 2: return 'limitedEdition';
      case 3: return 'common';
      case 4: return 'common';
      case 5: return 'common';
      case 6: return 'common'; 
    }
  }

  public static getSeriesNameAbbreviation(series: number): string {
    switch (series) {
      case -1: return 'All-Time'
      case 0: return 'Contemporary'
      case 1: return 'S1'
      case 2: return 'S2'
      case 3: return 'Sum21'
      case 4: return 'S3'
      case 5: return 'S4'
      case 6: return 'S5'
    }
  }  

  public static getSeriesName(series: number): string {
    switch (series) {
      case -1: return 'All-Time'
      case 0: return 'Contemporary'
      case 1: return 'Series 1'
      case 2: return 'Series 2'
      case 3: return 'Summer 2021'
      case 4: return 'Series 3'
      case 5: return 'Series 4'
      case 6: return 'Series 5'
    }
  }

  public static getSeriesNameCompletionDescription(series: number, teamname: string, locked: boolean): string {
    switch (series) {
      case -1: return `${locked ? 'Locked' : 'Own'} a moment of every ${teamname} player across all series.`
      case 0: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player across all series.`
      case 1: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series 1.`
      case 2: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series 2.`
      case 3: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series Summer 2021.`
      case 4: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series 3.`
      case 5: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series 4.`
      case 6: return `${locked ? 'Locked' : 'Own'} a moment of every non-historical ${teamname} player in Series 5.`
    }
  }  

}


(async () => {
})();

